import type { Theme } from '@mui/material';
import { listItemClasses } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_LIST_STYLE = 'data-0';

export default function MUIList(theme: Theme) /* : Components['MuiList'] */ {
  return {
    // defaultProps: {},
    variants: [
      ...['initial', 'decimal', 'square'].map((listStyle) => ({
        props: { [CUSTOM_ATTRIBUTE_LIST_STYLE]: listStyle },
        style: {
          listStyle,
          paddingLeft: theme.spacing(4),
          [`.${listItemClasses.root}`]: {
            display: 'list-item',
            paddingLeft: theme.spacing(1),
          },
        },
      })),
    ],
    styleOverrides: {
      dense: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
    // variants: [],
  };
}
